var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import AntAutoComplete from 'antd/lib/auto-complete';
import Input from 'antd/lib/input';
import { getParentNode } from '../../utils';
var AutoComplete = /** @class */ (function (_super) {
    __extends(AutoComplete, _super);
    function AutoComplete(props) {
        var _this = _super.call(this, props) || this;
        _this.onSearch = function (value) {
            if (_this.props.onSearch) {
                _this.props.onSearch();
            }
            _this.setState({
                dataSource: value && !value.match(/[a-z|%]/gi)
                    ? _this.props.dataSource.map(function (key) { return ({ value: "" + value + key }); })
                    : []
            });
        };
        _this.onChangeEnd = function (e) {
            var target = e.target;
            var v = target ? target.value : e;
            if (v !== _this.props.value) {
                var o = {
                    showAll: false,
                    value: v
                };
                _this.setState(o);
                _this.props.onChange(v);
            }
        };
        _this.onChange = function (value) {
            _this.setState({
                value: value
            });
        };
        _this.state = {
            dataSource: [],
            value: props.value
        };
        return _this;
    }
    AutoComplete.getDerivedStateFromProps = function (props, _a) {
        var prevProps = _a.prevProps;
        var nextState = {
            prevProps: props
        };
        if (prevProps && prevProps.value !== props.value) {
            nextState.value = props.value;
        }
        return nextState;
    };
    AutoComplete.prototype.render = function () {
        var _this = this;
        var _a = this.props, onChange = _a.onChange, dataSource = _a.dataSource, size = _a.size, props = __rest(_a, ["onChange", "dataSource", "size"]);
        var _b = this.state, value = _b.value, options = _b.dataSource;
        return (React.createElement(AntAutoComplete, __assign({}, props, { value: value || undefined, options: options, onSearch: this.onSearch, onChange: this.onChange, onBlur: this.onChangeEnd, onSelect: this.onChangeEnd, placeholder: this.props.placeholder || '--', dropdownMatchSelectWidth: false, dropdownClassName: "editor-list-dropdown", getPopupContainer: function (node) { return getParentNode(node, 'editor-list'); } }),
            React.createElement(Input, { size: size, onPressEnter: function (e) {
                    _this.onChangeEnd(e.target.value);
                } })));
    };
    AutoComplete.propTypes = {
        onSearch: PropTypes.func,
        dataSource: PropTypes.array,
        placeholder: PropTypes.string,
        size: PropTypes.string,
        onChange: PropTypes.func,
        value: PropTypes.string
    };
    AutoComplete.defaultProps = {
        dataSource: ['px', '%', 'rem', 'em', 'vw', 'vh'],
        size: 'small'
    };
    return AutoComplete;
}(React.Component));
export default AutoComplete;
